import { Avatar, Button, Card } from "@material-ui/core";
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import * as React from "react";
import { IDomainUserInDTO } from '../../../repository/jago/model/input/IDomainUserInDTO';
import AbilityProvider from '../../../services/PermissionService/AbilityProvider';
import { PERMISSIONS, Roles } from '../../../services/PermissionService/PermissionConstants';
import ReduxLanguage from "../../ReduxLanguage";
import { BLUE } from "../../../style/StyleConsts";
import { DeleteOutlined, PeopleAltOutlined } from "@material-ui/icons";

const styles = createStyles({
  rowContainer: {
    display: 'flex',
    margin: 10,
    justifyContent: 'space-between',
    padding: 20,
  },
  rowActionBodyContainer: {
    padding: 15,
    minHeight: 100,
  },
  rowBodyContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowBodyContainerOuter: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  rowTitle: {
    fontWeight: 'bold',
  },
  avatar: {
    color: 'white',
    marginRight: 10,
    backgroundColor: '#0D47A1',
    fontSize: 15,
  },
  icon: {
    color: 'lightskyblue',
    fontSize: 20,
  },
});

export interface IDomainUserRowProps extends WithStyles<typeof styles> {
  user?: IDomainUserInDTO;
  onDeleteUserRequest?: () => void;
  onClick?: () => void;
}

class DomainUserRow extends React.Component<IDomainUserRowProps, any> {
  public render() {
    const { user, classes, onClick, onDeleteUserRequest } = this.props;
    return (
      <Card className={classes.rowContainer}>
        {onClick ? (
          <div className={classes.rowBodyContainerOuter}>
            <div className={classes.rowBodyContainer}>
              <Avatar className={classes.avatar}>
                {`${user?.firstname[0].toUpperCase()}${user?.lastname[0].toUpperCase()}`}
              </Avatar>
              <div>
                <h4 className={classes.rowTitle}>
                  {`${user?.firstname} ${user?.lastname}`}
                </h4>
                <h4>{user?.email}</h4>
              </div>
              {user?.enabled ? (
                <h5 style={{ color: 'green', marginLeft: 20, fontWeight: 'bold' }}>
                  <ReduxLanguage languageKey={'forms.active'} />
                </h5>
              ) : (
                <h5 style={{ color: 'red', marginLeft: 20, fontWeight: 'bold' }}>
                  <ReduxLanguage languageKey={'forms.disabled'} />
                </h5>
              )}
            </div>
            <div>
            {onDeleteUserRequest && AbilityProvider.getAbilityHelper().hasRoles([Roles.ROLE_VASHO_SOFIA_ADMIN]) && user.email !== 'support@sofialocks.com' ? (
              <Button
                onClick={() => onDeleteUserRequest()}
                variant="contained"
                style={{ fontWeight: 'bold', backgroundColor: 'darkred', fontSize: 11, color: 'white', marginRight: 30 }}>
                <ReduxLanguage languageKey="forms.delete" />
                <DeleteOutlined className={classes.icon} style={{ color: 'white', marginLeft: 5 }}/>
              </Button>
            ) : null}
            {user && user.enabled && AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.DOMAIN_IMPERSONATE_SUPPORT)?(
              <Button
                onClick={() => onClick()}
                variant="contained"
                style={{ fontWeight: 'bold', backgroundColor: BLUE, fontSize: 11, color: 'white' }}>
                <ReduxLanguage languageKey="domains.impersonate" />
                <PeopleAltOutlined className={classes.icon} style={{ color: 'white', marginLeft: 5 }}/>
              </Button>
            ) : null}
            </div>
          </div>
        ) : (
          <div className={classes.rowBodyContainerOuter}>
            <div className={classes.rowBodyContainer}>
              <Avatar className={classes.avatar}>
                {`${user?.firstname[0].toUpperCase()}${user?.lastname[0].toUpperCase()}`}
              </Avatar>
              <div>
                <h4 className={classes.rowTitle}>
                  {`${user?.firstname} ${user?.lastname}`}
                </h4>
                <h4>{user?.email}</h4>
              </div>
              {user?.enabled ? (
                <h5 style={{  color: 'green', marginLeft: 20, fontWeight: 'bold' }}>
                  <ReduxLanguage languageKey={'forms.active'} />
                </h5>
              ) : (
                <h5 style={{  color: 'red', marginLeft: 20, fontWeight: 'bold' }}>
                  <ReduxLanguage languageKey={'forms.disabled'} />
                </h5>
              )}
            </div>
            {onDeleteUserRequest && AbilityProvider.getAbilityHelper().hasRoles([Roles.ROLE_VASHO_SOFIA_ADMIN]) && user.email !== 'support@sofialocks.com' ? (
              <Button
                onClick={() => onDeleteUserRequest()}
                variant="contained"
                style={{ fontWeight: 'bold', backgroundColor: 'darkred', fontSize: 11, color: 'white', marginRight: 30 }}>
                <ReduxLanguage languageKey="forms.delete" />
                <DeleteOutlined className={classes.icon} style={{ color: 'white', marginLeft: 5 }}/>
              </Button>
            ) : null}
          </div>
        )}
      </Card>
    );
  }
}

export default withStyles(styles)(DomainUserRow);